<template>
  <div>
    <new-post-box :post_types="post_types" :onSharePostSuccess="onSharePostSuccess"></new-post-box>

    <div class="card is-bg-transparent is-no-box-shadow">
      <header class="card-header is-no-box-shadow">
        <div class="is-hidden-mobile" style="display: flex; width: 100%;">
          <p class="card-header-title has-text-dark">
            <i class="fas fa-stream fa-lg"></i>&nbsp;&nbsp;&nbsp;Timeline
          </p>
          <div class="buttons">
            <post-filters :dataProvider="dataProvider" :clickHandler="refreshPosts"></post-filters>
          </div>
        </div>
        <div class="is-hidden-tablet" style="margin-bottom: 10px;">
          <p class="card-header-title has-text-dark">
            <i class="fas fa-stream fa-lg"></i>&nbsp;&nbsp;&nbsp;Timeline
          </p>
          <div class="buttons">
            <post-filters :dataProvider="dataProvider" :clickHandler="refreshPosts"></post-filters>
          </div>
        </div>
      </header>
      <div class="card-content is-no-box-shadow is-no-padding">
        <div v-if="!loading_get_posts_refresh && posts.length > 0" :class="is_edit ? 'is-disabled' : ''">
          <!-- START POST TYPE -->
          <post-item v-for="(post, index) in posts"
            :key="index"
            :group="post.group"
            :post="post"
            :user="post.user"
            :selectMedia="selectMedia"
            @getPosts="getPosts"
            :editPost="editPost"
            :setPosts="setPosts"
            :setPostsDataProvider="setPostsDataProvider"
            :showCommentLists="true" />

          <pagination v-if="!loading_get_posts" :dataProvider="dataProvider" :clickHandler="getPosts" :infinity_scroll="true"></pagination>

          <div v-if="loading_get_posts">
            <spinner-loading></spinner-loading>
          </div>

          <!-- Edit Post -->
          <edit-post-box v-if="!isEmpty(selected_post)" :postData="selected_post" :onSharePostSuccess="onSharePostSuccess"></edit-post-box>
        </div>

        <br/>
        <div class="box" v-if="(!loading_get_posts && !loading_get_posts_refresh) && posts.length <= 0">
          <p class="help" style="font-size:1em;">Postingan tidak ditemukan.</p>
        </div>

        <div v-if="loading_get_posts_refresh">
          <spinner-loading></spinner-loading>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PostItem from '~/components/molecules/posts/PostItem';
import NewPostBox from '~/components/molecules/NewPostBox';
import EditPostBox from '~/components/molecules/EditPostBox';
import PostFilters from '~/components/PostFilters';
import { mapState, mapMutations, mapActions } from 'vuex';
import { POST, GROUP } from '~/consts';

export default {
  components: {
    PostItem,
    NewPostBox,
    EditPostBox,
    PostFilters
  },

  mounted() {
    if (this.isEmpty(this.$route.query.status) || this.isEmpty(this.$cookies.get('_postdata'))) {
      this.getPosts(true);
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      pt: state => state.auth.active_pt,
      show_add_box: state => state.posts.show_add_box
    }),
    submit_text() {
      return this.is_edit ? 'Perbarui' : 'Bagikan';
    },
    canAddConference() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("add_conference_learning_material") === true;
    },
    canIntegrateZoomInAcademicClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_academic_class") === true;
    },
    canIntegrateZoomInGeneralClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_general_class") === true;
    },
    post_types() {
      let types = ['M', 'Q', 'Z', 'I', 'S', 'E'];

      if (!this.isEmpty(this.pt)) {
        if (
          ['ADMIN', 'LECTURER'].indexOf(this.pt.type) > -1 &&
          (this.canAddConference || this.canIntegrateZoomInAcademicClass || this.canIntegrateZoomInGeneralClass)
        ) {
          types.push('V');
        } else if (['STUDENT'].indexOf(this.pt.type) > -1) {
          types = ['I', 'S', 'E']
        }
      }

      return types
    }
  },

  data() {
    return {
      media_ext_s: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'jpg', 'jpeg', 'png', 'gif'],
      loading_save: false,
      loading_get_posts: false,
      loading_get_posts_refresh: false,
      selected_media: null,
      enable_ended_at: false,
      is_edit: false,
      posts: [],
      selected_post: null,
      dataProvider: {
        criterion: [
          {
            operator: 'EQ',
            value: 'classes',
            criteria: 'type',
            custom: true
          }, {
            operator: 'LK',
            value: '',
            criteria: 'title,description'
          }
        ],
        page: {
          count: 0,
          current: this.$route.query.page !== undefined ? this.$route.query.page : 1,
          limit: 5,
          next: 1,
          previous: 1,
          total: 0
        },
        sort: []
      },
      medias: []
    }
  },

  methods: {
    ...mapActions({
      fetchPosts: 'posts/getAll',
      storePost: 'posts/storePost',
      updatePost: 'posts/updatePost'
    }),
    ...mapMutations({
      toggleBox: 'posts/toggleBox'
    }),
    getPosts(refresh = false) {
      const vm = this;

      if (refresh) {
        this.dataProvider.page.current = 1;
        vm.loading_get_posts_refresh = true;
      } else {
        vm.loading_get_posts = true;
      }

      this.$axios.post(POST.GET_TIMELINE, {dataProvider: JSON.stringify(this.dataProvider)})
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let posts = collect(vm.posts);

            if (!refresh) {
              let post_ids = posts.pluck('id').toArray();
              posts = posts.toArray().concat(collect(data.data.data).filter((p) => {
                if (post_ids.indexOf(p.id) > -1) {
                  return false;
                }

                return true;
              }).toArray());
            } else {
              posts = data.data.data;
            }

            Vue.nextTick(() => {
              vm.setPosts(collect(posts).toArray());
              vm.setPostsDataProvider(data.data.dataProvider);
            })
          }

          if (refresh) {
            vm.loading_get_posts_refresh = false;
          } else {
            vm.loading_get_posts = false;
          }
        }).catch(() => {
          vm.loading_get_posts_refresh = false;
          vm.loading_get_posts = false;
        })
    },
    setPosts(posts) {
      this.posts = posts;
      this.selected_post = null
    },
    setPostsDataProvider(dataProvider) {
      this.dataProvider = dataProvider;
    },
    editPost(post) {
      this.selected_post = this.transformKeysTo(post)
    },
    refreshPosts() {
      this.getPosts(true);
    },
    selectMedia(media) {
      if (['document', 'link'].indexOf(media.type) > -1) {
        if (media.type == 'link' && !this.isEmpty(media.link)) {
          window.open(media.link,'_blank');
        } else if ( media.type == "document" && media.storageType == 'google_drive' && !this.isEmpty(media.values) ) {
          window.open(media.values.webViewLink, "_blank");
        } else if (media.type == 'document' && !this.isEmpty(media.file) && !this.isEmpty(media.file.link)) {
          this.openDocument(media.file.link);
        }
      }
    },
    onSharePostSuccess() {
      this.getPosts(true)
    }
  }
}
</script>

<style scoped>
#box_manager {
  border: none !important;
}
.file-attachment {
  margin: 7px 0 !important;
}
.btn-submit {
  border: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.btn-cancel {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
